import { SET_ROUTE, SET_LAST_ROUTE, SET_ROUTE_COOPERATIVE, SET_FORCE_NOT_FOUND } from 'reducers/actions-types';

export default Object.freeze({
    set({ route }) {
        return { type: SET_ROUTE, route };
    },
    setCooperative({ cooperative }) {
        return { type: SET_ROUTE_COOPERATIVE, cooperative };
    },
    setLastRoute({ lastRoute }) {
        return { type: SET_LAST_ROUTE, lastRoute };
    },
    setForceNotFound({ mustForceNotFound }) {
        return { type: SET_FORCE_NOT_FOUND, mustForceNotFound };
    },
});



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/router/actions.js